import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import BulkUploadTeachers from './BulkUploadTeachers';
import UpdateTeacherDetails from './UpdateTeacherDetails';
import TeacherAttendance from './TeacherAttendance';
import SalaryManagement from './SalaryManagement';
import BankAccountVerification from './BankAccountVerification';
import RecruitmentApplications from './RecruitmentApplications';

interface HRModuleProps {
  domain: string;
  onBack: () => void;
}

const HRModule: React.FC<HRModuleProps> = ({ domain, onBack }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('bulkupload');

  // Update active tab based on current route
  useEffect(() => {
    const path = location.pathname;
    if (path.includes('/update')) setActiveTab('update');
    else if (path.includes('/attendance')) setActiveTab('attendance');
    else if (path.includes('/salary')) setActiveTab('salary');
    else if (path.includes('/bank-accounts')) setActiveTab('bank-accounts');
    else if (path.includes('/recruitment')) setActiveTab('recruitment');
    else setActiveTab('bulkupload');
  }, [location.pathname]);

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <div className="bg-primary-custom text-white p-3 shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <h4 className="mb-0">
            <i className="bi bi-people me-2"></i>
            Human Resources Management
          </h4>
          <button className="btn btn-light btn-sm" onClick={onBack}>
            <i className="bi bi-arrow-left me-2"></i>
            Back to Dashboard
          </button>
        </div>
      </div>

      {/* Tab Navigation */}
      <div className="bg-white shadow-sm">
        <div className="container-fluid">
          <ul className="nav nav-tabs border-0">
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'bulkupload' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr')}
              >
                <i className="bi bi-cloud-upload me-2"></i>
                Bulk Upload Teachers
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'update' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr/update')}
              >
                <i className="bi bi-pencil-square me-2"></i>
                Update Teacher Details
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'attendance' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr/attendance')}
              >
                <i className="bi bi-calendar-check me-2"></i>
                Teacher Attendance
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'salary' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr/salary')}
              >
                <i className="bi bi-cash-coin me-2"></i>
                Salary Management
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'bank-accounts' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr/bank-accounts')}
              >
                <i className="bi bi-bank me-2"></i>
                Bank Account Verification
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === 'recruitment' ? 'active' : ''}`}
                onClick={() => navigate('/dashboard/hr/recruitment')}
              >
                <i className="bi bi-person-plus me-2"></i>
                Recruitment
              </button>
            </li>
          </ul>
        </div>
      </div>

      {/* Content Area */}
      <div className="container-fluid py-4">
        <Routes>
          <Route index element={<BulkUploadTeachers domain={domain} />} />
          <Route path="update" element={<UpdateTeacherDetails domain={domain} />} />
          <Route path="attendance" element={<TeacherAttendance domain={domain} />} />
          <Route path="salary" element={<SalaryManagement domain={domain} />} />
          <Route path="bank-accounts" element={<BankAccountVerification domain={domain} />} />
          <Route path="recruitment" element={<RecruitmentApplications domain={domain} />} />
        </Routes>
      </div>
    </div>
  );
};

export default HRModule;
